import { Like } from '@depop/web-thrift-ui/Illustrations/Like';
import { useTranslations } from 'next-intl';

import { useGuestLikesToast } from '../GuestLikeToastProvider';
import { GUEST_LIKED_PRODUCTS_STORAGE_LIMIT } from '../constants';

import { useSignup } from '@/modules/signup/hooks/useSignup';

export function useShowGuestLikesToast() {
  const t = useTranslations('common');
  const { send } = useGuestLikesToast();
  const { url } = useSignup();

  return () =>
    send({
      title: t('GuestLikesToast.Title', {
        count: GUEST_LIKED_PRODUCTS_STORAGE_LIMIT,
      }),
      description: t('GuestLikesToast.Description'),
      illustration: <Like size="xSmall" />,
      cta: { title: t('GuestLikesToast.SignUp'), href: url },
    });
}
